import { VehicleMapDataPoint } from "../../../api/types/VehicleMap";
import { VehicleStatusCode } from "../../../api/types/VehicleStatusCode";
import { APP_CONFIG } from "../../../constants/constants";

export const getTripStartEndPoints = (tripPoints: VehicleMapDataPoint[]) => {
  // not using statuscode to find trip start and end points
  // const tripStartPoint = tripPoints
  //   .find(tripPoint =>
  //     tripPoint.status.statuscode === VehicleStatusCode.STATUS_IGNITION_ON
  //     && !!tripPoint.latitude && !!tripPoint.longitude
  //   );
  // const tripEndPoint = tripPoints
  //   .find(tripPoint =>
  //     tripPoint.status.statuscode === VehicleStatusCode.STATUS_IGNITION_OFF
  //     && !!tripPoint.latitude && !!tripPoint.longitude
  //   );
  const tripStopStatusPoints = tripPoints.filter(
    (tripPoint) =>
      tripPoint.status.statuscode === VehicleStatusCode.STATUS_IGNITION_OFF &&
      !!tripPoint.latitude &&
      !!tripPoint.longitude
  );

  const tripStartPoint = tripPoints[0];
  const tripEndPoint =
    tripStopStatusPoints.length > 0
      ? tripStopStatusPoints[tripStopStatusPoints.length - 1] // last ignition off point
      : tripPoints[tripPoints.length - 1];
  return { tripStartPoint, tripEndPoint };
};

export const getTripStartEndOdometerKMWOffset = (
  tripPoints: VehicleMapDataPoint[]
) => {
  const tripStartOdometerKMWOffset =
    tripPoints[0].odometerkm + tripPoints[0].odometeroffsetkm;
  const tripEndOdometerKMWOffset =
    tripPoints[tripPoints.length - 1].odometerkm +
    tripPoints[tripPoints.length - 1].odometeroffsetkm;
  return { tripStartOdometerKMWOffset, tripEndOdometerKMWOffset };
};

// `getGroupableEventCodes` deprecated
// client does not want the feature to be bound with status codes
// export const getGroupableEventCodes = (tripPoint: VehicleMapDataPoint) => {
//   let groupableEventCodesKey = Object.keys(
//     APP_CONFIG.MAPS.ASSET_MAP_SHOW_SINGLE_MARKER_FOR_EVENT_CODES
//   ).find((eventCodeGroupKey, k) =>
//     APP_CONFIG.MAPS.ASSET_MAP_SHOW_SINGLE_MARKER_FOR_EVENT_CODES[
//       eventCodeGroupKey as keyof typeof APP_CONFIG.MAPS.ASSET_MAP_SHOW_SINGLE_MARKER_FOR_EVENT_CODES
//     ].includes(tripPoint.statuscode)
//   );
//   let groupableEventCodes = !!groupableEventCodesKey
//     ? APP_CONFIG.MAPS.ASSET_MAP_SHOW_SINGLE_MARKER_FOR_EVENT_CODES[
//         groupableEventCodesKey as keyof typeof APP_CONFIG.MAPS.ASSET_MAP_SHOW_SINGLE_MARKER_FOR_EVENT_CODES
//       ]
//     : undefined;
//   return groupableEventCodes;
// };
